import UtilSP from "SATPROF_UTILS/UtilSP";
//import THREE from 'THREE_BOOTSTRAP';
//import { Vector2, LessDepth } from 'three';

export default class Complex {
  /**

 * <p>
 * This class also contains many static methods that accept <code>Complex</code>
 * arguments and return appropriate values.  In general, the <code>static</code> methods
 * in this class qre similar to the <code>static</code> methods in class 
 * <code>java.lang.Math</code>.
 * Examples include <code>sin(z)</code>, <code>cos(z)</code>, <code>tan(z)</code>,
 * <code>log(z)</code>, etc.
 * <p>
 * Class <code>Complex</code> is a subclass of <code>number</code>, and it
 * overrides all of the abstract methods in that class.  The overridden
 * methods in class <code>Complex</code> work with the <i>real part</i> of the
 * <code>Complex</code> number only.
 * <p>
 * This class also implements the <code>java.lang.Comparable</code> interface.
 * In this case, the comparisons are between the <i>absolute values</i> of the
 * two <code>Complex</code> numbers.
 *
 
 /*  
Static functions (operate on args; no existing object required)
	toString(z:Complex):String	Returns a string representation of z 
 	abs(z:Complex ):number
	arg( z:Complex  ):number
	acos( z:Complex ):Complex
	acosh( z:Complex ):Complex
	asin( z:Complex ):Complex
	asinh( z:Complex ):Complex 
	atan( z:Complex):Complex
	atanh (need to translate)
	make() or make(x) or make(x,y)	Returns a new Complex object
	conj( z:Complex ):Complex
	cos( z:Complex ):Complex
	exp( z:number ):Complex
	imag( z:Complex ):number
	inv(z:Complex ):Complex
	log( z:Complex ):Complex
	norm( z:Complex ):number
	phase( c:Complex ):number
	polar(r:number, theta:number):Complex
	pow( base, exponent ):Complex
	real( z:Complex ):number
	sin(  z:Complex):Complex 
	sqrt ( z:Complex):Complex
	tan( z:Complex ):Complex 
	sqrt1( z:Complex ):Void
	mulCA( a, b ):Array			Returns element-by-element multiplication of arrays a and b
	addCA(a, b)  Returns the element-by-element sum of two Complex arrays. 
	realCA( a ):Array			Returns array of numbers representing the real part of a.
	magCA(a):Array
	
Complex object constructor
	Complex()		Creates z = 0
	Complex(x)  	Creates z = x +j0
	Complex(x, y)  	Creates z = x + jy

Complex object properties
	re
	im
	mag (read only)
	magdB (read only)
	angRad (read only)
	angDeg (read only)
	
Complex object methods
	getRe():number 
	getIm():number
	setIm( im:number ):Void
	setRe( re:number ):void
	setZ( re:number, im:number ):void 
	calcAbs():number
	calcArg():number
  calcConj():Complex
	calcInv():Complex    
	calcNeg():Complex    
	calcPow(  exponent ):Complex
  clone():Complex
	addC(z):Complex
	subC(z):Complex
	mulC(z):Complex  // DO NOT USE FOR SCALE MULTIPLY
	divC(z):Complex   // DO NOT USE FOR SCALE DIVIDE
	isInfiniteComplex():boolean
	isNaNComplex():boolean    
	equals ():boolean   
	compareTo( anotherComplex:Complex):number 
  setMagAngDeg
  setMagdBAngDeg(magdB, aDeg)
	
	
*/
  // Constants
  public static I: Complex = new Complex(0.0, 1.0);
  public static J: Complex = new Complex(0.0, 1.0);

  // Instance variables
  public re: number;
  public im: number;

  constructor(reArg?: number, imArg?: number) {
    if (reArg == undefined && imArg == undefined) {
      // No parameters: constructs a Complex object representing the number zero.
      this.re = 0;
      this.im = 0;
    } else if (imArg == undefined) {
      // constructs a Complex object from a real number.
      this.re = reArg;
      this.im = 0;
    } else {
      // Constructs a Complex object from real and imag numbers.
      this.re = reArg;
      this.im = imArg;
    }
    /* ////
                }else if ( arguments[0] is Complex ){
                re = arguments[0].re;
                im = arguments[0].im;
            }
            break;
            */
  }
  //*************************************************
  // Static methods
  //*************************************************
  public static toString( z: Complex | Array<Complex> | number | string, decPlaces:number = 4  ): string {
    let maStr: string;
    if (z instanceof Complex) {
      maStr =
        "mag = " +
        Math.sqrt(z.re * z.re + z.im * z.im).toFixed(decPlaces) +
        ", ang = " +
        UtilSP.degrees(Math.atan2(z.im, z.re)).toFixed(decPlaces);
      if (z.im < 0.0) {
        return "Complex: (" + z.re + " - j " + -z.im.toFixed(decPlaces) + ")" + "; " + maStr;
      } else if (1.0 / z.im == Number.NEGATIVE_INFINITY) {
        return "Complex: (" + z.re.toFixed(decPlaces) + " + j " + 0.0 + ")" + "; " + maStr;
      } else {
        return "Complex: (" + z.re.toFixed(decPlaces) + " + j " + +z.im.toFixed(decPlaces) + ")" + "; " + maStr;
      }
    } else if (z instanceof Array) {
      let s: string = "Array (length = " + z.length + "):\n";
      for (let i = 0; i < z.length; i++) {
        if (z[i] instanceof Complex) {
          let t: string;
          maStr =
            "mag = " +
            Math.sqrt(z[i].re * z[i].re + z[i].im * z[i].im) +
            ", ang = " +
            UtilSP.degrees(Math.atan2(z[i].im, z[i].re));
          if (z[i].im < 0.0) {
            t = "(" + z[i].re + " - j " + -z[i].im + ")" + "; " + maStr;
          } else if (1.0 / z[i].im == Number.NEGATIVE_INFINITY) {
            t = "(" + z[i].re + " + j " + 0.0 + ")" + "; " + maStr;
          } else {
            t = "(" + z[i].re + " + j " + +z[i].im + ")" + "; " + maStr;
          }
          s = s + "  [" + i + "] (Complex) = " + t + "\n";
        } else if (typeof z[i] == "number") {
          s = s + "  [" + i + "] (number) = " + z[i] + "\n";
        } else if (typeof z[i] == "string") {
          s = s + "  [" + i + "] (String) = " + z[i] + "\n";
        } else {
          s = s + "  [" + i + "] = " + z[i] + "\n";
        }
      }
      return s;
    } else if (typeof z == "number") {
      return "number: " + z;
    } else if (typeof z == "string") {
      return "String: = " + String(z) + "\n";
    } else {
      return "Error in function toString: only Complex and Array values are supported.";
    }
  }
  public static abs(z: Complex): number {
    // Returns the absolute value (magnitude) of a <tt>Complex</tt> number.
    let absRe: number;
    absRe = Math.abs(z.re);
    let absIm: number;
    absIm = Math.abs(z.im);
    let d: number;

    // This algorithm avoids overflows that might otherwise
    // occur when evaluating Math.sqrt(re*re + im*im);
    if (absRe == 0.0 && absIm == 0.0) {
      return 0;
    } else if (absRe >= absIm) {
      d = z.im / z.re;
      return absRe * Math.sqrt(1.0 + d * d);
    } else {
      d = z.re / z.im;
      return absIm * Math.sqrt(1.0 + d * d);
    }
  }
  public static arg(z: Complex): number {
    /* Returns the principal angle of a Complex number, in
     * radians, measured counter-clockwise from the real axis.
     * Always returns a number between -pi and +pi. */
    return Math.atan2(z.im, z.re);
  }

  public static acos(z: Complex): Complex {
    /* Returns the principal inverse cosine of a <tt>Complex</tt> number.
     *     acos(z) = -i * log( z + i * sqrt(1 - z*z) )
     */
    let re1: number, im1: number; // (1 - z*z)
    let re2: number, im2: number; // i * sqrt(1 - z*z)
    let re3: number, im3: number; // log(z + i * sqrt(1 - z*z))
    let result: Complex; // Result of intermediate calcs

    // Build (1 - z*z)
    re1 = 1.0 - (z.re * z.re - z.im * z.im);
    im1 = 0.0 - (z.re * z.im + z.im * z.re);

    // Build sqrt(1 - z*z)
    result = Complex.make(re1, im1);
    Complex.sqrt1(result);

    // Build i * sqrt(1 - z*z)
    re2 = -result.im;
    im2 = +result.re;

    // Build z + i * sqrt(1 - z*z)
    result.re = z.re + re2;
    result.im = z.im + im2;

    // Build log(z + i * sqrt(1 - z*z))
    re3 = Math.log(Complex.abs(result));
    im3 = Complex.arg(result);

    // Build -i * log(z + i * sqrt(1 - z*z))
    result.re = im3;
    result.im = -re3;
    return result;
  }

  public static acosh(z: Complex): Complex {
    /* Returns the principal inverse hyperbolic cosine of a
     * <tt>Complex</tt> number.
     * <pre>
     *     acosh(z) = log(z + sqrt(z*z - 1))
     */
    let re1: number, im1: number; // (z*z + 1)
    let re2: number, im2: number; // log(z + sqrt(z*z - 1))
    let result: Complex; // Result of intermediate calcs

    // Build (z*z - 1)
    re1 = z.re * z.re - z.im * z.im - 1.0;
    im1 = z.re * z.im + z.im * z.re;

    // Build sqrt(z*z - 1)
    result = Complex.make(re1, im1);
    Complex.sqrt1(result);

    // Build z + sqrt(z*z - 1)
    result.re = z.re + result.re;
    result.im = z.im + result.im;

    // Build log(z + sqrt(z*z - 1))
    re2 = Math.log(Complex.abs(result));
    im2 = Complex.arg(result);

    // Build acosh(z)
    result.re = re2;
    result.im = im2;
    return result;
  }

  public static asin(z: Complex): Complex {
    /* Returns the principal inverse sine of a <tt>Complex</tt> number.
     *     asin(z) = -<i>i</i> * log(<i>i</i>*z + sqrt(1 - z*z))
     */
    let re1: number, im1: number; // (1 - z*z)
    let re2: number, im2: number; // i*z
    let re3: number, im3: number; // log (i*z + sqrt(1 - z*z))
    let result: Complex; // Result of intermediate calcs

    // Build (1 - z*z)
    re1 = 1.0 - (z.re * z.re - z.im * z.im);
    im1 = 0.0 - (z.re * z.im + z.im * z.re);

    // Build sqrt(1 - z*z)
    result = Complex.make(re1, im1);
    Complex.sqrt1(result);

    // Build iz = i*z
    re2 = -z.im;
    im2 = +z.re;

    // Build i*z + sqrt(1 - z*z)
    result.re = re2 + result.re;
    result.im = im2 + result.im;

    // Build log (i*z + sqrt(1 - z*z))
    re3 = Math.log(Complex.abs(result));
    im3 = Complex.arg(result);

    // Build -i * log (i*z + sqrt(1 - z*z))
    result.re = im3;
    result.im = -re3;
    return result;
  }

  public static asinh(z: Complex): Complex {
    /* Returns the principal inverse hyperbolic sine of a Complex number.
     *     asinh(z) = log(z + sqrt(z*z + 1))
     */

    let re1: number, im1: number; // (z*z + 1)
    let re2: number, im2: number; // log(z + sqrt(z*z + 1))
    let ans: Complex; // Intermediate results of calc

    // Build z*z + 1
    re1 = z.re * z.re - z.im * z.im + 1.0;
    im1 = z.re * z.im + z.im * z.re;

    // Build sqrt(z*z + 1)
    ans = Complex.make(re1, im1);
    Complex.sqrt1(ans);

    // Build z + sqrt(z*z + 1)
    ans.re = z.re + ans.re;
    ans.im = z.im + ans.im;

    // Build log(z + sqrt(z*z + 1))
    re2 = Math.log(ans.calcAbs());
    im2 = ans.calcArg();

    // Build asinh(z)
    ans.re = re2;
    ans.im = im2;
    return ans;
  }

  public static atan(z: Complex): Complex {
    /* Returns the principal inverse tangent of a <tt>Complex</tt> number.
         atan(z) = -<i>i</i>/2 * log( (<i>i</i>-z)/(<i>i</i>+z) ) 
	*/

    let re1: number, im1: number; // (i+z)
    let re2: number, im2: number; // log((i-z)/(i+z))
    let result: Complex; // Intermediate results of calc

    // Build (i-z)
    result = Complex.make(-z.re, 1.0 - z.im);

    // Build (i+z)
    re1 = z.re;
    im1 = 1.0 + z.im;

    // Build (i-z)/(i+z)
    Complex.divC2(result, re1, im1);

    // Build log((i-z)/(i+z))
    re2 = Math.log(Complex.abs(result));
    im2 = Complex.arg(result);

    // Build -i/2 * log((i-z)/(i+z))
    result.re = 0.5 * im2;
    result.im = -0.5 * re2;
    return result;
  }

  /**
   * Returns the principal inverse hyperbolic tangent of a
   * <tt>Complex</tt> number.
   * <pre>
   *     atanh(z) = 1/2 * log( (1+z)/(1-z) )
   * </pre>
   * @param   z   a <tt>Complex</tt> number
   * @return  the <tt>Complex</tt> result
   * @see     Complex#tanh(Complex)
   */
  /*
   public static Complex atanh( Complex z ) {

      double re1, im1;   // (1 - z)
      double re2, im2;   // log((1+z)/(1-z))
      Complex result;    // Intermediate results of calc

      // Build (1+z)
      result = Complex.make(1.0 + z.re, + z.im);

      // Build (1-z)
      re1 = 1.0 - z.re;
      im1 = -z.im;

      // Build (1+z)/(1-z)
      Complex.divC2(result, re1, im1);

      // Build log((1+z)/(1-z))
      re2 = Math.log(Complex.abs(result));
      im2 = Complex.arg(result);

      // Build atanh(z) = 0.5*log((1+z)/(1-z))
      result.re = 0.5 * re2;
      result.im = 0.5 * im2;
      return result;
   }
*/

  public static make(reArg: number = 0, imArg: number = 0): Complex {
    /* Creates a new Complex number from a number.  The imaginary
     * part of is initialized to zero. */
    let ans: Complex;
    switch (arguments.length) {
      case 0:
        ans = new Complex(0, 0);
        return ans;
        break;
      case 1:
        // 1 number parameter: constructs a Complex object from a real number.
        ans = new Complex(arguments[0], 0);
        return ans;
        break;
      case 2:
        // 2 number parameters: constructs a Complex object from real & imag numbers.
        ans = new Complex(arguments[0], arguments[1]);
        return ans;
        break;
      default:
        console.log(
          "ERROR in Complex.make: more than 2 arguments.  Returning 0,0."
        );
        ans = new Complex(0, 0);
        return ans;
    }
  }
  public static sumWithReal(z:Complex, x:number):Complex{
  
    return new Complex( z.re + x, z.im);
  }

  public static conj(z: Complex): Complex {
    // Returns the Complex conjugate of a Complex number.
    return Complex.make(z.re, -z.im);
  }

  public static cos(z: Complex): Complex {
    /* Returns the cosine of a Complex number.
         cos(z) = ( exp(i*z) + exp(-i*z) ) / (2*i)
    */

    let scalar: number;
    let izRe: number, izIm: number; // Real and imag parts of iz
    let re1: number, im1: number; // Real and imag parts of exp(i*z)
    let re2: number, im2: number; // Real and imag parts of exp(-i*z)

    // Build i*z
    izRe = -z.im;
    izIm = z.re;

    // Build exp(i*z) using Euler's equation
    scalar = Math.exp(izRe);
    re1 = scalar * Math.cos(izIm);
    im1 = scalar * Math.sin(izIm);

    // Build exp(-i*z)
    scalar = Math.exp(-izRe);
    re2 = scalar * Math.cos(-izIm);
    im2 = scalar * Math.sin(-izIm);

    // Build exp(i*z) + exp(-i*z)
    re1 = re1 + re2;
    im1 = im1 + im2;

    // result: (exp(i*z) + exp(-i*z)) / 2
    return Complex.make(0.5 * re1, 0.5 * im1);
  }

  /**
   * Returns the hyperbolic cosine of a <tt>Complex</tt> number.
   * <pre>
   *     cosh(z) = ( exp(z) + exp(-z) ) / 2
   * </pre>
   * @param   z   a <tt>Complex</tt> value
   * @return  the <tt>Complex</tt> hyperbolic cosine
   * @see     Complex#acosh(Complex)
   */

  public static cosh(z: Complex): Complex {
    let re1: number, im1: number; // Real and imag parts of exp(z)
    let re2: number, im2: number; // Real and imag parts of exp(-z)
    let scalar: number;

    // Build exp(z)
    scalar = Math.exp(z.re);
    re1 = scalar * Math.cos(z.im);
    im1 = scalar * Math.sin(z.im);

    // Build exp(-z)
    scalar = Math.exp(-z.re);
    re2 = scalar * Math.cos(-z.im);
    im2 = scalar * Math.sin(-z.im);

    // Build exp(z) + exp(-z)
    re1 = re1 + re2;
    im1 = im1 + im2;

    // cosh(z) = ( exp(z) + exp(-z) ) / 2
    return Complex.make(0.5 * re1, 0.5 * im1);
  }

  public static exp(z: Complex): Complex {
    /* Returns the e raised to the power of the Complex value z. */
    let scalar: number = Math.exp(z.re);
    return Complex.make(scalar * Math.cos(z.im), scalar * Math.sin(z.im));
  }

  public static imag(z: Complex): number {
    // Returns the imaginary part of a Complex number
    return z.im;
  }

  public static inv(z: Complex): Complex {
    //Returns the reciprocal of a <tt>Complex</tt> number (1/z).
    let x: number = z.re;
    let y: number = z.im;
    let scalar: number, zRe, zIm;

    // Calculate to minimize roundoff errors.  This algorithm is
    // taken from "Numerical Recipes in Fortran 77: The Art of
    // Scientific Computing", by Press et al
    if (Math.abs(x) >= Math.abs(y)) {
      scalar = 1.0 / (x + y * (y / x));
      zRe = scalar;
      zIm = -scalar * (y / x);
    } else {
      scalar = 1.0 / (x * (x / y) + y);
      zRe = scalar * (x / y);
      zIm = -scalar;
    }
    return Complex.make(zRe, zIm);
  }

  public static log(z: Complex): Complex {
    // Returns the principal natural logarithm of a Complex number.

    return Complex.make(Math.log(Complex.abs(z)), Complex.arg(z));
  }

  public static norm(z: Complex): number {
    /* Returns the L2 norm of a <tt>Complex</tt> number, which is the
     * sum of the squares of the real and imaginary parts. */
    return z.re * z.re + z.im * z.im;
  }

  public static phase(c: Complex): number {
    /* Returns the phase of a Complex value in radians.  Note that
    this method duplicates the functionality of the arg method. */
    return Math.atan2(c.im, c.re);
  }

  public static polar(r: number, theta: number): Complex {
    //Returns a new Complex from a magnitude and angle in radians.
    //
    if (r < 0.0) {
      theta += Math.PI;
      r = -r;
    }
    theta = theta % (2 * Math.PI);
    return Complex.make(r * Math.cos(theta), r * Math.sin(theta));
  }
  public static magdBangdeg( magdB:number, angdeg:number):Complex{
    let r:number = UtilSP.dB2Vratio(magdB);
    let theta:number = UtilSP.radians(angdeg);
    return Complex.polar(r, theta);
  }

  public static pow(base, exponent): Complex {
    // Returns the Complex base raised to the power of the number exponent.
    // return  exp( exponent * log(base) );
    let re: number;
    let im: number;
    let re2: number;
    let im2: number;
    let scalar: number;

    if (base instanceof Complex && typeof exponent === "number") {
      re = exponent * Math.log(Complex.abs(base));
      im = exponent * Complex.arg(base);

      scalar = Math.exp(re);
      return Complex.make(scalar * Math.cos(im), scalar * Math.sin(im));
    } else if (typeof base === "number" && exponent instanceof Complex) {
      re = Math.log(Math.abs(base));
      im = Math.atan2(0.0, base);

      re2 = re * exponent.re - im * exponent.im;
      im2 = re * exponent.im + im * exponent.re;

      scalar = Math.exp(re2);

      return Complex.make(scalar * Math.cos(im2), scalar * Math.sin(im2));
    } else if (base instanceof Complex && exponent instanceof Complex) {
      re = Math.log(Complex.abs(base));
      im = Complex.arg(base);

      re2 = re * exponent.re - im * exponent.im;
      im2 = re * exponent.im + im * exponent.re;

      scalar = Math.exp(re2);

      return Complex.make(scalar * Math.cos(im2), scalar * Math.sin(im2));
    } else {
      console.log("ERROR in Complex.pow: invalid parameters.  Returning 0,0.");
      return Complex.make(0, 0);
    }
  }

  public static real(z: Complex): number {
    /**
     * Returns the real part of a <tt>Complex</tt> as a <tt>double</tt>.
     *
     * @param  z  <tt>Complex</tt> number
     * @return  <tt>double</tt> containing the real part of z
     * @see  Complex#re()
     */
    return z.re;
  }

  public static sin(z: Complex): Complex {
    /**
     * Returns the sine of a <tt>Complex</tt> number.
     * <pre>
     *     sin(z) = ( exp(<i>i</i>*z) - exp(-<i>i</i>*z) ) / (2*<i>i</i>)
     * </pre>
     * @param   z   an angle, in radians.
     * @return  the <tt>Complex</tt> sine
     * @see     Complex#asin(Complex)
     */

    let scalar: number;
    let izRe: number, izIm: number; // Real and imag parts of iz
    let re1: number, im1: number; // Real and imag parts of exp(i*z)
    let re2: number, im2: number; // Real and imag parts of exp(-i*z)

    // Build i*z
    izRe = -z.im;
    izIm = z.re;

    // Build exp(i*z)
    scalar = Math.exp(izRe);
    re1 = scalar * Math.cos(izIm);
    im1 = scalar * Math.sin(izIm);

    // Build exp(-i*z)
    scalar = Math.exp(-izRe);
    re2 = scalar * Math.cos(-izIm);
    im2 = scalar * Math.sin(-izIm);

    // Build exp(i*z) - exp(-i*z)
    re1 = re1 - re2;
    im1 = im1 - im2;

    // result: (exp(i*z) - exp(-i*z)) / 2
    return Complex.make(0.5 * im1, -0.5 * re1);
  }

  /**
   * Returns the hyperbolic sine of a <tt>Complex</tt> number.
   * <pre>
   *     sinh(z) = ( exp(z) - exp(-z) ) / 2
   * </pre>
   * @param   z   a <tt>Complex</tt> value
   * @return  the <tt>Complex</tt> hyperbolic sine
   * @see     Complex#asinh(Complex)
   */

  public static sinh(z: Complex): Complex {
    let re1: number, im1: number; // Real and imag parts of exp(z)
    let re2: number, im2: number; // Real and imag parts of exp(-z)
    let scalar: number;

    // Build exp(z)
    scalar = Math.exp(z.re);
    re1 = scalar * Math.cos(z.im);
    im1 = scalar * Math.sin(z.im);

    // Build exp(-z)
    scalar = Math.exp(-z.re);
    re2 = scalar * Math.cos(-z.im);
    im2 = scalar * Math.sin(-z.im);

    // Build exp(z) - exp(-z)
    re1 = re1 - re2;
    im1 = im1 - im2;

    // Build sinh(z) = ( exp(z) - exp(-z) ) / 2
    return Complex.make(0.5 * re1, 0.5 * im1);
  }

  public static sqrt(z: Complex): Complex {
    /**
     * Returns the square root of a <code>Complex</code> value.
     * @param   z   a <code>Complex</code> value.
     * @return  the square root of <code>z</code>.
     */
    // adapted from "Numerical Recipies in C" by Press et al

    let re: number = 0,
      im: number = 0;
    let u: number = 0,
      v: number = 0;
    let mag: number = z.calcAbs();
    let temp: number;

    if (mag > 0.0) {
      if (z.re > 0.0) {
        temp = Math.sqrt(0.5 * (mag + z.re));
        re = temp;
        im = (0.5 * z.im) / temp;
      } else {
        temp = Math.sqrt(0.5 * (mag - z.re));
        if (z.im < 0.0) {
          temp = -temp;
        }
        re = (0.5 * z.im) / temp;
        im = temp;
      }
    } else {
      re = 0.0;
      im = 0.0;
    }
    return Complex.make(re, im);
  }

  public static tan(z: Complex): Complex {
    /**
     * Returns the tangent of a <tt>Complex</tt> number.
     * <pre>
     *     tan(z) = sin(z) / cos(z)
     * </pre>
     * @param   z   a <tt>Complex</tt> angle
     * @return  the <tt>Complex</tt> tangent
     * @see     Complex#atan(Complex)
     */

    let result: Complex; // Result of calculation
    let scalar: number; // Scalar
    let izRe: number, izIm: number; // Real and imag parts of iz
    let re1: number, im1: number; // Real and imag parts of exp(i*z)
    let re2: number, im2: number; // Real and imag parts of exp(-i*z)
    let re3: number, im3: number; // exp(i*z) - exp(-i*z)
    let re4: number, im4: number; // exp(i*z) + exp(i*z)
    let cosRe: number, cosIm: number; // cos(z)

    // First, calculate sin(z):

    // Build iz = i * z
    izRe = -z.im;
    izIm = z.re;

    // Build z1 = exp(iz)
    scalar = Math.exp(izRe);
    re1 = scalar * Math.cos(izIm);
    im1 = scalar * Math.sin(izIm);

    // Build z2 = exp(-iz)
    scalar = Math.exp(-izRe);
    re2 = scalar * Math.cos(-izIm);
    im2 = scalar * Math.sin(-izIm);

    // Build z3 = z1 - z2
    re3 = re1 - re2;
    im3 = im1 - im2;

    // Build sin(z) = z3 / (2*i)
    result = Complex.make(0.5 * im3, -0.5 * re3);

    // Now, calculate cos(z):

    // z4 = z1 + z2
    re4 = re1 + re2;
    im4 = im1 + im2;

    // cos(z) = z4 / 2
    cosRe = 0.5 * re4;
    cosIm = 0.5 * im4;

    // tan(z) = sin(z) / cos(z)
    Complex.divC2(result, cosRe, cosIm);
    return result;
  }

  /**
   * Returns the hyperbolic tangent of a <tt>Complex</tt> number.
   * <pre>
   *     tanh(z) = sinh(z) / cosh(z)
   * </pre>
   * @param   z   a <tt>Complex</tt> value
   * @return  the <tt>Complex</tt> hyperbolic tangent
   * @see     Complex#atanh(Complex)
   */
  /*
   public static Complex tanh( Complex z ) {
      //  tanh(z)  =  sinh(z) / cosh(z)

      Complex result;        // Result of calculation
      double scalar;         // Scalar
      double izRe, izIm;     // Real and imag parts of iz
      double re1, im1;       // Real and imag parts of exp(z)
      double re2, im2;       // Real and imag parts of exp(-z)
      double re3, im3;       // exp(z) - exp(-z)
      double re4, im4;       // exp(z) + exp(z)
      double coshRe, coshIm; // cosh(z)

      // sinh(z) = (exp(z) - exp(-z)) / 2
      // cosh(z) = (exp(z) + exp(-z)) / 2
      // tanh(z) = (exp(z) - exp(-z)) / (exp(z) + exp(-z))

      // z1 = exp(z)
      scalar =  Math.exp(z.re);
      re1 =  scalar * Math.cos(z.im);
      im1 =  scalar * Math.sin(z.im);

      // z2 = exp(-z)
      scalar =  Math.exp(-z.re);
      re2 =  scalar * Math.cos(-z.im);
      im2 =  scalar * Math.sin(-z.im);

      // z3 = exp(z) - exp(-z)
      re3 =  re1 - re2;
      im3 =  im1 - im2;

      // z4 = exp(z) + exp(-z)
      re4 =  re1 + re2;
      im4 =  im1 + im2;

      // tanh(z) = z3 / z4
      result = Complex.make( re3, im3 );
      Complex.divC2( result, re4, im4 );
      return result;
   }
*/
  public static sqrt1(z: Complex) {
    /**
     * Implements square root of a <tt>Complex</tt> value, returning the result
     * in the same object as the input value.
     */
    // adapted from "Numerical Recipies in C" by William H. Press et al

    let re: number = 0,
      im: number = 0;
    let u: number = 0,
      v: number = 0;
    let mag: number = z.calcAbs();
    let temp: number;

    if (mag > 0.0) {
      if (z.re > 0.0) {
        temp = Math.sqrt(0.5 * (mag + z.re));
        re = temp;
        im = (0.5 * z.im) / temp;
      } else {
        temp = Math.sqrt(0.5 * (mag - z.re));
        if (z.im < 0.0) {
          temp = -temp;
        }
        re = (0.5 * z.im) / temp;
        im = temp;
      }
    } else {
      re = 0.0;
      im = 0.0;
    }

    // Return results
    z.re = re;
    z.im = im;
  }

  public static mulCA(a: any, b: any): any {
    //public static mulCA(a:Array<number>|Array<Complex>, b:number|Complex|Array<number>|Array<Complex>) {
    /**
    * Returns the element-by-element product of two Complex arrays. 
	a must be an array of numbers or an array of Complex
	b may be a number, a Complex, an array of numbers, or an array of Complex
	*/
    let ans: Array<Complex> = [];
    let i: number;
    if (a instanceof Array && b instanceof Array) {
      if (a.length != b.length) {
        console.log(
          "ERROR in Complex.mulCA: a.length = " +
            a.length +
            " not equal to b.length " +
            b.length
        );
        return NaN;
      }
      let N = a.length;
      for (i = 0; i < a.length; i++) {
        if (a[i] instanceof Complex && b[i] instanceof Complex) {
          ans[i] = Complex.make(
            a[i].re * b[i].re - a[i].im * b[i].im,
            a[i].re * b[i].im + a[i].im * b[i].re
          );
        } else if (a[i] instanceof Complex && typeof b[i] == "number") {
          ans[i] = Complex.make(a[i].re * b[i], a[i].im * b[i]);
        } else if (typeof a[i] == "number" && b[i] instanceof Complex) {
          ans[i] = Complex.make(a[i] * b[i].re, a[i] * b[i].im);
        } else if (typeof a[i] == "number" && typeof b[i] == "number") {
          ans[i] = Complex.make(a[i] * b[i], 0);
        }
      }
      return ans;
    } else if (
      a instanceof Array &&
      (typeof b == "number" || b instanceof Complex)
    ) {
      //console.log("Multiplying by number");
      //console.log("a = "+toString(a));
      //console.log("b = "+toString(b));
      for (i = 0; i < a.length; i++) {
        if (a[i] instanceof Complex && b instanceof Complex) {
          ans[i] = Complex.make(
            a[i].re * b.re - a[i].im * b.im,
            a[i].re * b.im + a[i].im * b.re
          );
        } else if (a[i] instanceof Complex && typeof b == "number") {
          ans[i] = Complex.make(a[i].re * b, a[i].im * b);
        } else if (typeof a[i] == "number" && b[i] instanceof Complex) {
          ans[i] = Complex.make(a[i] * b[i].re, a[i] * b[i].im);
        } else if (typeof a[i] == "number" && typeof b == "number") {
          ans[i] = Complex.make(a[i] * b, 0);
        }
      }
      //console.log("ans = "+toString(ans));
      return ans;
    }
  }
  public static addCA(a: any, b: any): any {
    /**
    * Returns the element-by-element sum of two Complex arrays. 
	a must be an array of numbers or an array of Complex
	b may be a number, a Complex, an array of numbers, or an array of Complex
	*/
    let N;
    let ans: Array<Complex>;
    let i;
    if (a instanceof Array && b instanceof Array) {
      if (a.length != b.length) {
        console.log(
          "ERROR in Complex.addCA: a.length = " +
            a.length +
            " not equal to b.length " +
            b.length
        );
        return NaN;
      }
      N = a.length;
      ans = new Array(N);
      for (i = 0; i < a.length; i++) {
        if (a[i] instanceof Complex && b[i] instanceof Complex) {
          ans[i] = Complex.make(a[i].re + b[i].re, a[i].im + b[i].im);
        } else if (a[i] instanceof Complex && typeof b[i] == "number") {
          ans[i] = Complex.make(a[i].re + b[i], a[i].im);
        } else if (typeof a[i] == "number" && b[i] instanceof Complex) {
          ans[i] = Complex.make(a[i] + b[i].re, b[i].im);
        } else if (typeof a[i] == "number" && typeof b[i] == "number") {
          ans[i] = Complex.make(a[i] + b[i], 0);
        }
      }
      return ans;
    } else if (
      a instanceof Array &&
      (typeof b == "number" || b instanceof Complex)
    ) {
      N = a.length;
      ans = new Array(N);
      //console.log("a = "+toString(a));
      //console.log("b = "+toString(b));
      for (i = 0; i < a.length; i++) {
        if (a[i] instanceof Complex && b instanceof Complex) {
          ans[i] = Complex.make(a[i].re + b.re, a[i].im + b.im);
        } else if (a[i] instanceof Complex && typeof b == "number") {
          ans[i] = Complex.make(a[i].re + b, a[i].im);
        } else if (typeof a[i] == "number" && b[i] instanceof Complex) {
          ans[i] = Complex.make(a[i] + b[i].re, b[i].im);
        } else if (typeof a[i] == "number" && typeof b == "number") {
          ans[i] = Complex.make(a[i] + b, 0);
        }
      }
      //console.log("ans = "+toString(ans));
      return ans;
    } else if (
      (typeof a == "number" || a instanceof Complex) &&
      (typeof b == "number" || b instanceof Complex)
    ) {
      //console.log("a = "+toString(a));
      //console.log("b = "+toString(b));
      let ansC: Complex;
      if (a instanceof Complex && b instanceof Complex) {
        ansC = Complex.make(a.re + b.re, a.im + b.im);
      } else if (a[i] instanceof Complex && typeof b == "number") {
        ansC = Complex.make(a[i].re + b, a[i].im);
      } else if (typeof a == "number" && b instanceof Complex) {
        ansC = Complex.make(a + b.re, b.im);
      } else if (typeof a[i] == "number" && typeof b == "number") {
        ansC = Complex.make(a[i] + b[i], 0);
      }

      //console.log("ans = "+toString(ans));
      return ansC;
    }
  }
  public static realCA(a: any): any {
    /**
    * Returns the element-by-element real part of a Complex array. 
	a must be an array of numbers or an array of Complex.
	*/
    let N: number;
    let ans: Array<number>;
    let i: number;
    if (a instanceof Array) {
      N = a.length;
      ans = new Array(N);
      for (i = 0; i < a.length; i++) {
        if (a[i] instanceof Complex) {
          ans[i] = a[i].re;
        } else if (typeof a[i] == "number") {
          ans[i] = a[i];
        }
      }
      return ans;
    } else if (typeof a == "number") {
      return a;
    } else if (a instanceof Complex) {
      return a.re;
    }
  }
  public static imagCA(a) {
    /**
    * Returns the element-by-element imaginary part of a Complex array. 
	a must be an array of numbers or an array of Complex.
	*/
    let N;
    let ans: Array<number>;
    let i;
    if (a instanceof Array) {
      N = a.length;
      ans = new Array(N);
      for (i = 0; i < a.length; i++) {
        if (a[i] instanceof Complex) {
          ans[i] = a[i].im;
        } else if (typeof a[i] == "number") {
          ans[i] = 0;
        }
      }
      return ans;
    } else if (typeof a == "number") {
      return 0;
    } else if (a instanceof Complex) {
      return a.im;
    }
  }
  public static magCA(a: any): Array<number> {
    /**
    * Returns the element-by-element magnitude of a Complex array. 
	a must be an array of numbers or an array of Complex.
	*/
    let N: number;
    let ans: Array<number>;
    let i: number;
    if (a instanceof Array) {
      N = a.length;
      ans = new Array(N);
      for (i = 0; i < a.length; i++) {
        if (a[i] instanceof Complex) {
          ans[i] = Complex.abs(a[i]);
        } else if (typeof a[i] == "number") {
          ans[i] = a[i];
        }
      }
    }
    return ans;
    /*
		} else if ( (typeof a) == "number" ){
			return a;
		} else if (a instanceof Complex ){
			return Complex.abs(a);
        }
        */
  }

  /*************************************************************************************************/
  //METHODS

  public calcAbs(): number {
    /* Returns the abs value of a Complex object.
     */
    let d;
    let absRe: number = Math.abs(this.re);
    let absIm: number = Math.abs(this.im);

    // This algorithm avoids overflows that might otherwise
    // occur when evaluating Math.sqrt(re*re + im*im);
    if (absRe == 0.0 && absIm == 0.0) {
      return 0;
    } else if (absRe >= absIm) {
      d = this.im / this.re;
      return absRe * Math.sqrt(1.0 + d * d);
    } else {
      d = this.re / this.im;
      return absIm * Math.sqrt(1.0 + d * d);
    }
  }

  public calcArg(): number {
    /**
     * Returns the principal angle of a <tt>Complex</tt> number, in
     * radians, measured counter-clockwise from the real axis.
     * Returns a number between -PI and +PI.
     */
    return Math.atan2(this.im, this.re);
  }

  public calcPhase(): number {
    // Duplicates calcArg.
    return Math.atan2(this.im, this.re);
  }

  public calcConj(): Complex {
    /**
     * Returns the <tt>Complex</tt> conjugate of a <tt>Complex</tt> object.
     * The <tt>Complex</tt> conjugate of a number is the complex number having
     * the same real component and the negative of the imaginary component.
     *
     * @return  <tt>Complex</tt> conjugate.
     * @see  Complex#conj(Complex)
     */
    return Complex.make(this.re, -this.im);
  }

  //*************************************************
  // Elementary operations
  //*************************************************

  public addC(z: Complex | number): Complex {
    /**
     * Returns the sum of two Complex values.  To perform z1 + z2,write z1.addC(z2).  
     Example: z1 = z2.addC(z3)

      Note that this method returns a Complex object, so calls to these methods can be chained.
     * For example,
     *     z1 + z2 + z3 == z1.addC(z2).addC(z3)
     * Parameter: z  Complex or Real
     */
    let sum: Complex;
    if (z instanceof Complex) {
      sum = Complex.make(this.re + z.re, this.im + z.im);
      return sum;
    } else {
      sum = Complex.make(this.re + z, this.im);
      return sum;
    }
  }

  public subC(z: any): Complex {
    /**
     * Returns the difference between two Complex values.
     * E.g.
     *     z1 - d2 = z1.subC(d2)
     * Parameter: z  Complex or Real
     */
    if (z instanceof Complex) {
      return Complex.make(this.re - z.re, this.im - z.im);
    } else {
      return Complex.make(this.re - z, this.im);
    }
  }

  public mulC(z: Complex | number): Complex {
    /**
     * Returns the product of two <tt>Complex</tt> values.  To perform z1 * z2,
     * write <tt>z1.mul(z2)</tt>.  Note that this method returns a <tt>Complex</tt> object,
     * so calls to these methods can be chained.  For example,
     * <pre>
     *     z1 * z2 / z3 == <tt>z1.mul(z2).divC(z3)</tt>
     * Parameter: z  Complex or Real
     */
    if (z instanceof Complex) {
      return Complex.make(
        this.re * z.re - this.im * z.im,
        this.re * z.im + this.im * z.re
      );
    } else {
      return Complex.make(this.re * z, this.im * z);
    }
  }

  public divC(z): Complex {
    /* Returns the division of two <tt>Complex</tt> values.  To perform z1 / z2,
     * write <tt>z1.div(z2)</tt>.  Note that this method returns a <tt>Complex</tt> object,
     * so calls to these methods can be chained.  For example,
     *     z1 * z2 / z3 == <tt>z1.mul(z2).div(z3)</tt>
     */
    if (z instanceof Complex) {
      let x: number = z.re;
      let y: number = z.im;
      let scalar: number, zRe: number, zIm: number;

      // Calculate to minimize roundoff errors.  This algorithm is
      // taken from "Numerical Recipes in Fortran 77: The Art of
      // Scientific Computing"
      if (Math.abs(x) >= Math.abs(y)) {
        scalar = 1.0 / (x + y * (y / x));
        zRe = scalar * (this.re + this.im * (y / x));
        zIm = scalar * (this.im - this.re * (y / x));
      } else {
        scalar = 1.0 / (x * (x / y) + y);
        zRe = scalar * (this.re * (x / y) + this.im);
        zIm = scalar * (this.im * (x / y) - this.re);
      }
      return Complex.make(zRe, zIm);
    } else {
      // z is real
      return Complex.make(this.re / z, this.im / z);
    }
  }
  //*************************************************
  // Private methods
  //*************************************************

  private static divC2(z: Complex, x: number, y: number) {
    /**
     * Implements division between two complex numbers, one expressed as
     * as a <tt>Complex</tt> and the other expressed as a pair of <tt>double</tt>s.
     * This approach allows us to return the result in the <tt>Complex</tt> object
     * without creating any new objects for garbage disposal.
     */

    let zRe: number, zIm: number; // Components of z
    let scalar: number;

    if (Math.abs(x) >= Math.abs(y)) {
      scalar = 1.0 / (x + y * (y / x));
      zRe = scalar * (z.re + z.im * (y / x));
      zIm = scalar * (z.im - z.re * (y / x));
    } else {
      scalar = 1.0 / (x * (x / y) + y);
      zRe = scalar * (z.re * (x / y) + z.im);
      zIm = scalar * (z.im * (x / y) - z.re);
    }

    // Return results in the complex object
    z.re = zRe;
    z.im = zIm;
  }
  //*************************************************
  // Accessors
  //*************************************************
  public get magdB(): number {
    return UtilSP.W2dBW(this.re * this.re + this.im * this.im);
  }
  public get mag(): number {
    return Math.sqrt(this.re * this.re + this.im * this.im);
  }  
  public setMagdBAngDeg(magdB: number, aDeg: number) {
    let a = UtilSP.radians(aDeg);
    let r = UtilSP.dB2Vratio(magdB);
    this.re = r * Math.cos(a);
    this.im = r * Math.sin(a);
  }
  public setMagAngDeg(mag: number, aDeg: number) {
    let a = UtilSP.radians(aDeg);
    let r = mag;
    this.re = r * Math.cos(a);
    this.im = r * Math.sin(a);
  }  
  public get angRad(): number {
    return this.calcArg();
  }
  public get angDeg(): number {
    return (this.calcArg() * 180) / Math.PI;
  }
  public getRe(): number {
    // Extracts the real part of a <tt>Complex</tt> object as a <tt>double</tt>.
    return this.re;
  }

  public getIm(): number {
    //Extracts the imaginary part of a <tt>Complex</tt> object as a <tt>double</tt>.
    return this.im;
  }

  public setIm(im: number) {
    // Sets a <tt>double</tt> value into the imaginary part of a <tt>Complex</tt> object.
    this.im = im;
  }

  public setRe(re: number) {
    // Sets a <tt>double</tt> value into the real part of a <tt>Complex</tt> object.
    this.re = re;
  }

  public setZ(re: number, im: number) {
    /**
     * Sets two <tt>double</tt> values into the real and imaginary
     * parts of a <tt>Complex</tt> object.
     */
    this.re = re;
    this.im = im;
  }

  public calcInv(): Complex {
    // Returns the reciprocal of a <tt>Complex</tt> number (1/z).
    let x: number = this.re;
    let y: number = this.im;
    let scalar: number, zRe: number, zIm: number;

    // Calculate to minimize roundoff errors.  This algorithm is
    // taken from "Numerical Recipes in Fortran 77: The Art of
    // Scientific Computing"
    if (Math.abs(x) >= Math.abs(y)) {
      scalar = 1.0 / (x + y * (y / x));
      zRe = scalar;
      zIm = -scalar * (y / x);
    } else {
      scalar = 1.0 / (x * (x / y) + y);
      zRe = scalar * (x / y);
      zIm = -scalar;
    }
    return Complex.make(zRe, zIm);
  }

  public calcNeg(): Complex {
    // Returns the negative of a <tt>Complex</tt> value.
    return Complex.make(-this.re, -this.im);
  }

  public calcPow(exponent: any): Complex {
    // Returns the <tt>Complex</tt> value raised to the power of the exponent.
    // return  exp( exponent * log(this) );
    let re: number;
    let im: number;
    let re2: number;
    let im2: number;
    let scalar: number;
    if (exponent instanceof Complex) {
      re = Math.log(this.calcAbs());
      im = this.calcArg();
      re2 = re * exponent.re - im * exponent.im;
      im2 = re * exponent.im + im * exponent.re;
      scalar = Math.exp(re2);
      return Complex.make(scalar * Math.cos(im2), scalar * Math.sin(im2));
    } else {
      // exponent is a number
      re = exponent * Math.log(this.calcAbs());
      im = exponent * this.calcArg();
      scalar = Math.exp(re);
      return Complex.make(scalar * Math.cos(im), scalar * Math.sin(im));
    }
  }
  public clone(){
    return Complex.make( this.re, this.im );
  }

  //*************************************************
  // Tests
  //*************************************************

  public isInfiniteComplex(): boolean {
    // Returns true if either the real or imaginary component of this Complex has an infinite value.
    return !(isFinite(this.re) && isFinite(this.im));
  }

  public isNaNComplex(): boolean {
    // Returns true if either the real or the imaginary component of this Complex is a Not-a-number (NaN).
    return isNaN(this.re) || isNaN(this.im);
  }
  /**
   * Decides if two <tt>Complex</tt> numbers are "sufficiently" alike to be
   * considered equal.  This test should be used cautiously because of the
   * inexact nature of floating-point representations on computers.  This
   * test takes the form <tt> z1.equals(z2)</tt>.  The tolerance for this
   * comparison is scaled automatically based on the sizes of the numbers
   * being compared.
   *
   * @param  z2    A <tt>Complex</tt> number
   * @return  <tt>true</tt> if equal; <tt>false</tt> otherwise
   * @see  Complex#equals(Complex,double)
   */
  public equals(cval, ctol: number = 1.0e-13): boolean {
    let tol;
    if (arguments.length == 1) {
      tol = 1.0e-13;
    } else {
      tol = arguments[1];
    }
    let tol1: number = 1.0e-13 * this.calcAbs();

    return (
      this.re - arguments[0].re <= tol1 && this.im - arguments[0].im <= tol1
    );
  }

  public compareTo(anotherComplex: Complex): number {
    /* Compares two <code>Complex</code> values numerically according to their absolute values.
     * param:
     *	anotherComplex   the Complex to be compared.
     * returns:
     *    0 	if the absolute values are equal
     *    -1	if the absolute value of this Complex is less than abs of the argument;
     *	 +1 if the absolute value of this Complex is greater than abs of the argument;
     */
    let thisVal = this.calcAbs();
    let anotherVal = anotherComplex.calcAbs();
    return thisVal < anotherVal ? -1 : thisVal == anotherVal ? 0 : 1;
  }
} // End class
